export default "__VITE_ASSET__f06f432c__"